const l = {
  name: "Uplift",
  dimensions: { width: 24, height: 24 },
  content: `
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#fff" d="M20 4h-5V2h7v7h-2zM20 11v11h2V11zM16 22v-7h2v7zM12 22v-3h2v3z" style="fill: currentColor;"/><path fill="#fff" d="M11 8h5v5h2V6h-7z" style="fill: currentColor;"/><path fill="#fff" d="M10.59 12H7v-2h7v7h-2v-3.582l-8.614 8.614-1.414-1.414z" style="fill: currentColor;"/></svg>
  `
};
export {
  l as Uplift
};
